import { message } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import ExportUtil from '../../common/ExportUtil';

export default function(searchArray, url, type) {
    const options = {
        method: 'POST',
        url: API_URL.common.startAsynchronousExport,
        data: { type },
        dataType: 'json',
        doneResult: (res) => {
            const { success, asynchronousExportId } = res;
            message.success(success);
            const params = { ...searchArray, asynchronousExportId }
            ExportUtil.export(params, null, url);
        },
    };
    $.sendRequest(options);
}


// WEBPACK FOOTER //
// ./src/components/shared/addToDownloadSite.js